/**
 * Плагин для работы с переключателями фич
 */
import { mapGetters } from 'vuex';

import featuresEnum from '@common/constants/features';

export default {
  install(app) {
    app.mixin({
      data: () => ({
        featuresEnum,
      }),

      computed: {
        ...mapGetters({
          $isFeatureEnabled: 'features/$isFeatureEnabled',
        }),
      },
    });
  },
};
